// Vendor Libs
import {cloneDeep, find, get, map, now, set} from 'lodash';

// Lib App
import actionsServiceCaller from './actions-service-caller';

// Core Libs
import {parseDurationAs} from '../lib-core/date';
import {parseJson} from '../lib-core/object';

// Configs
import servicesFormConfig from '../../config/services-form-config';

const formMiddleware = store => next => action => {
    const {dispatch, getState} = store;
    next(action);
    const nextState = getState();
    const actions = {
        DELETE_OFFERING_FULFILLED: () => updateFormData(dispatch, action.formName, nextState),
        FORM_REGISTER: () => formRegistered(dispatch, action.formName, nextState),
        FORM_SUBMIT_ASYNC_LOCATION: () => fetchAsyncLocation(dispatch, action),
        FORM_SUBMIT_FETCH: () => fetchFormData(dispatch, action, nextState.formData),
        FORM_SUBMIT_FULFILLED: () => updateFormData(dispatch, action.formName, nextState),
        MAPPING_POST_FULFILLED: () => updateFormData(dispatch, action.formName, nextState),
        REPUBLISH_MEDIAITEM_FULFILLED: () => updateFormData(dispatch, action.formName, nextState),
    };

    if (actions[action.type]) {
        return actions[action.type]();
    }
};

function formRegistered(dispatch, formName, nextState) {
    const {dependentServicesDataKey} = servicesFormConfig[formName] || {};

    if (dependentServicesDataKey) {
        const lastUpdated = get(nextState, ['servicesSearchData', dependentServicesDataKey, 'lastUpdated']);

        if (!lastUpdated) {
            dispatch({type: 'SEARCH_DATA_REGISTER_STORE', servicesDataKey: dependentServicesDataKey});
        } else if (now() - 1000 > lastUpdated) {
            dispatch({type: 'SEARCH_DATA_REFRESH', servicesDataKey: dependentServicesDataKey});
        }
    }
}

function fetchAsyncLocation(dispatch, {formName, location, servicesDataKey}) {
    const dispatchFetched = jsonResponse => {
        if (find(jsonResponse.content, ['status', 'RUNNING'])) {
            dispatch({
                type: 'FORM_SUBMIT_ASYNC_LOCATION',
                formName,
                location,
                response: jsonResponse,
            });
        } else {
            dispatch({
                type: 'FORM_SUBMIT_FULFILLED',
                async: true,
                formName,
                response: parseJson(get(jsonResponse.content, '0.result')),
            });
        }
    };
    const dispatchError = error => {
        dispatch({
            type: 'FORM_SUBMIT_REJECTED',
            async: true,
            formName,
            formErrors: error,
        });
    };
    const actionParams = {
        servicesConfig: servicesFormConfig.async,
        dispatchFetched,
        dispatchError,
    };
    dispatch({
        type: 'FORM_SUBMIT_ASYNC',
        formName,
    });

    setTimeout(() => actionsServiceCaller(actionParams, {}, location), 2725);
}

function fetchFormData(dispatch, {async, formName, servicesDataKey}, formData) {
    const values = cloneDeep(formData[formName].values);
    const dispatchFetched = (jsonResponse, response) => {
        const status = get(response, 'status');
        const location = get(response, 'headers.location');

        if (status === 202 && location) {
            dispatch({
                type: 'FORM_SUBMIT_ASYNC_LOCATION',
                formName,
                location,
                response: jsonResponse,
            });
        } else {
            dispatch({
                type: 'FORM_SUBMIT_FULFILLED',
                formName,
                response: jsonResponse,
            });
        }
    };
    const dispatchError = error => {
        dispatch({
            type: 'FORM_SUBMIT_REJECTED',
            formName,
            formErrors: error,
        });
    };
    const actionParams = {
        servicesConfig: {
            ...servicesFormConfig[servicesDataKey || formName],
        },
        dispatchFetched,
        dispatchError,
    };
    dispatch({
        type: 'FORM_SUBMIT',
        formName,
    });

    if (async) {
        set(actionParams.servicesConfig, 'getParams.async', 'true');
    }

    return actionsServiceCaller(actionParams, values, get(formData, [formName, 'requestPath']));
}

function updateFormData(dispatch, formName, newState) {
    const {dependentServicesDataKey, updateServicesDataKeys} = servicesFormConfig[formName] || {};

    map([dependentServicesDataKey, ...(updateServicesDataKeys || [])], servicesDataKey => {
        if (servicesDataKey && newState.servicesSearchData[servicesDataKey]) {
            dispatch({type: 'SEARCH_DATA_REFRESH', servicesDataKey});
        }
    });
}

function resetFormData(dispatch) {
    dispatch({type: 'FORM_RESET', resetStore: true});
}

export default formMiddleware;
